import loadRecaptchaScript from './loadRecaptchaScript';
import renderRecaptchaWidget from './renderRecaptchaWidget';

/**
 * @module google-recaptcha/initAndRenderRecaptchaWidget
 *
 * @description Метод вызывает загрузку скрипта Google ReCaptcha, если он ещё не был загружен, а затем рендерит виджет капчи в переданном блоке.
 *
 * Метод может быть использован для рендера капчи в различных кастомных формах.
 * Также, метод используется в обработчиках стандартных форм в качестве фоллбека на тот случай если Intersection Observer API отработает некорректно.
 *
 * Примечания:
 * (!) Если ничего не передать в метод, то произойдёт попытка загрузить скрипт капчи, если он ещё не загружен.
 *
 * (!) Блок передаваемый в качестве аргумента (recaptchaBlock) должен быть пустым
 *
 * (!) Если у переданного блока есть атрибут data-recaptcha-type="invisible", то будет вызван рендер ReCaptcha V3 Invisible.
 *
 * @param {HTMLElement} recaptchaBlock - DOM-элемент, в котором будет рендериться капча.
 *
 * @param {string} formType - Для ReCaptcha V2. Тип формы, для которой рендерится капча. Возможные значения: "feedback", "comment", "review".
 * После верификации в форму будет добавлено поле input[name="formType[g-recaptcha-response]"]
 *
 * @param {Object} context - Вручную передавать не нужно, используется только для фоллбека из наших UI-компонентов форм.
 *
 * @example
 * window.reCaptchaCommon.render(document.querySelector('.js-captcha-block'), 'feedback');
 *
 * @returns {void}
 */
export default function(recaptchaBlock, formType = '', context) {
  const renderCallback = () => {
    if (recaptchaBlock.children.length) {
      console.warn('Попытка рендера ReCaptcha в блоке, который уже содержит элементы. ', recaptchaBlock);
      window.EventBus.unsubscribe('recaptcha-api:insales:loaded', renderCallback);

      return;
    }

    let isInvisible = false;

    if (recaptchaBlock.dataset.recaptchaType === 'invisible') {
      isInvisible = true;

      recaptchaBlock.dataset.size = 'invisible';

      if (!recaptchaBlock.dataset.badge) {
        recaptchaBlock.dataset.badge = 'bottomleft';
      }

      let recaptchaTypeInput = document.createElement('input');
      recaptchaTypeInput.type = 'hidden';
      recaptchaTypeInput.name = 'recaptcha_type';
      recaptchaTypeInput.value = 'invisible';

      recaptchaBlock.after(recaptchaTypeInput);
    }

    try {
      renderRecaptchaWidget(recaptchaBlock, formType, context, isInvisible);
      window.EventBus.unsubscribe('recaptcha-api:insales:loaded', renderCallback);
    } catch (catchErrorMessage) {
      console.warn('grecaptcha error', catchErrorMessage);
    }
  };

  if (recaptchaBlock) {
    window.EventBus.subscribe('recaptcha-api:insales:loaded', renderCallback);
  }

  window.recaptchaAPICallback = function() {
    window.EventBus.publish('recaptcha-api:insales:loaded', null);
  };

  if (
    window.Shop.config.config.feedback_captcha_enabled
    || window.Shop.config.theme_settings.feedback_captcha_enabled
  ) {
    loadRecaptchaScript('recaptchaAPICallback', window.Shop.config.get('locale').locale, window.recaptchaAPICallback);
  }
}
